import { generateTypes } from '../../utils/HttpReducerHelper';

export const deleteFundingReport = generateTypes('FUNDING_REPORT', 'DELETE');
export const deleteFundingReportNewHub = generateTypes('FUNDING_REPORT', 'DELETE_NEW_HUB');

export const OPEN_DELETE_FUNDING_REPORT_MODAL =
  'platfi-ui-app/FUNDING_REPORT/OPEN_DELETE_FUNDING_REPORT_MODAL';
export const CLOSE_DELETE_FUNDING_REPORT_MODAL =
  'platfi-ui-app/FUNDING_REPORT/CLOSE_DELETE_FUNDING_REPORT_MODAL';
